import { createTheme } from '@mui/material/styles';

import ProximaNovaLight from '../assets/fonts/proximanova-regularit-webfont.woff2';
import ProximaNovaRegular from '../assets/fonts/proximanova-regular-webfont.woff2';
import ProximaNovaMedium from '../assets/fonts/proximanova-medium-webfont.woff2';
import ProximaNovaSemiBold from '../assets/fonts/proximanova-semibold-webfont.woff2';

import noImagePng from '../assets/no-image.png';
import noImageDarkPng from '../assets/no-image-dark.png';

// eslint-disable-next-line
export default (useDarkMode) => createTheme({
  typography: {
    fontFamily: ['Proxima Nova', 'sans-serif'].join(','),
  },
  palette: {
    mode: useDarkMode ? 'dark' : 'light',
    ...(useDarkMode ? {
            backgroundMedium: 'rgba(118, 118, 128, 0.32)',
            backgroundSemi: 'rgba(0, 0, 0, 0.5)',
            missingAssetImage: noImageDarkPng,
       } : {
            backgroundMedium: 'rgba(118, 118, 128, 0.12)',
            backgroundSemi: 'rgba(193, 193, 193, 0.5)',
            missingAssetImage: noImagePng,
       })
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: "Proxima Nova";
          src: url("${ProximaNovaLight}") format("woff2");
          font-weight: 300;
          font-style: normal;
        }

        @font-face {
          font-family: "Proxima Nova";
          src: url("${ProximaNovaRegular}") format("woff2");
          font-weight: 400;
          font-style: normal;
        }

        @font-face {
          font-family: "Proxima Nova";
          src: url("${ProximaNovaMedium}") format("woff2");
          font-weight: 500;
          font-style: normal;
        }

        @font-face {
          font-family: "Proxima Nova";
          src: url("${ProximaNovaSemiBold}") format("woff2");
          font-weight: 600;
          font-style: normal;
        }
      `,
    },
    MuiButton: {
      styleOverrides: {
        root: {
          whiteSpace: 'nowrap',
        },
      },
    },
  },
});
